import React, { useEffect, useState } from 'react';
import API_BASE_URL from '../Config';


const TicketPrinter = ({ ventaId }) => {
  const [venta, setVenta] = useState(null);

useEffect(() => {
  if (ventaId) {
    fetch(`${API_BASE_URL}/api/ventas/${ventaId}`)
      .then(res => res.json())
      .then(data => {
        console.log("🧾 Datos del ticket recibidos:", data);
        setVenta(data);
      })
      .catch(err => console.error("❌ Error al cargar ticket:", err));
  }
}, [ventaId]);

  if (!venta) return <p className="p-4">Cargando ticket...</p>;

  const cantidades = venta.cantidad.split('-');
  const nombres = venta.nombre.split('|').map(s => s.trim());
  const precios = venta.precioNormalPorProducto.split('-');

  const items = nombres.map((desc, index) => {
    const cantidad = parseInt(cantidades[index]) || 0;
    const precio = parseFloat(precios[index]) || 0;
    return {
      cantidad,
      descripcion: desc,
      precioUnitario: precio,
      totalItem: cantidad * precio,
      tasa: venta.productoId.split('-')[index] === '1' ? 10 : 5, // Ajustar lógica según necesidad real
    };
  });

  return (
    <div className="p-4 font-mono text-sm max-w-md mx-auto bg-white shadow">
      <h2 className="text-center font-bold">FACTURA CONTADO Nro: {venta.id}</h2>
      <p>Fecha: {new Date(venta.fecha).toLocaleString()}</p>
      <p>CI/RUC: {venta.registerProcess || 'X'}</p>
      <p>Cliente: Sin Nombre</p>
      <p>País: PARAGUAY</p>
      <hr className="my-2" />

      <table className="w-full text-left">
        <thead>
          <tr>
            <th>Cant</th>
            <th>Desc</th>
            <th>P.U.</th>
            <th>P.T.</th>
            <th>Tasa%</th>
          </tr>
        </thead>
        <tbody>
          {items.map((item, i) => (
            <tr key={i}>
              <td>{item.cantidad}</td>
              <td>{item.descripcion}</td>
              <td>{item.precioUnitario}</td>
              <td>{item.totalItem}</td>
              <td>{item.tasa}</td>
            </tr>
          ))}
        </tbody>
      </table>

      <hr className="my-2" />
      <p>Total a pagar en Gs: <strong>{venta.total.toLocaleString()}</strong></p>

      <hr className="my-2" />
      <p>Subtotales:</p>
      <p>Grav10%: {venta.gravada10}</p>
      <p>Grav5%: {venta.gravada5}</p>
      <p>Exenta: {venta.exenta}</p>
      <p>IVA 10%: {venta.liquidacion10}</p>
      <p>IVA 5%: {venta.liquidacion5}</p>
      <p>Tot. IVA: {venta.totalIva}</p>

      <hr className="my-2" />
      <p>Forma de pago: {venta.metodoPago}</p>

      <div className="mt-4 text-center">
      
      </div>
    </div>
  );
};

export default TicketPrinter;
